// src/pages/DebtStudio/lib/costs.js
export function computeCOIItems(items = [], parAmount = 0) {
  const par = Number(parAmount) || 0;

  return (Array.isArray(items) ? items : []).map((item) => {
    const rateType = (item?.rateType || "fixed").toLowerCase();
    const raw = Number(item?.amount) || 0;

    let computedAmount = 0;
    if (rateType === "fixed") computedAmount = raw;
    else if (rateType === "per1000") computedAmount = (par / 1000) * raw;
    else if (rateType === "percent") computedAmount = (par * raw) / 100;

    return {
      ...item,
      computedAmount, // dollar value for this line item
    };
  });
}

export function computeTotalCOI(items = [], parAmount = 0) {
  return computeCOIItems(items, parAmount)
    .reduce((sum, it) => sum + (Number(it.computedAmount) || 0), 0);
}
